import React, { useState } from 'react';
import { ChevronRight, Lock } from 'lucide-react';
import { buildDonateUrl } from '../utils/donate';
function formatAmount(amount: number): string {
  if (amount >= 1000) return `$${(amount / 1000).toFixed(0)}K`;
  return `$${amount}`;
}
export function DonateModule() {
  const [selectedAmount, setSelectedAmount] = useState<number | 'custom'>(100);
  const [customAmount, setCustomAmount] = useState('');
  const presetAmounts = [25, 50, 100, 250, 500, 1000];
  const resolvedAmount = selectedAmount === 'custom' ? Number.parseFloat(customAmount) : selectedAmount;
  const isContributeDisabled = !resolvedAmount || Number.isNaN(resolvedAmount) || resolvedAmount <= 0;
  const handleContribute = () => {
    if (isContributeDisabled) return;
    window.open(buildDonateUrl(resolvedAmount), '_blank', 'noopener,noreferrer');
  };
  return <div id="donate" className="scroll-mt-24 bg-white rounded-xl shadow-2xl overflow-hidden border border-slate-200 w-full max-w-md mx-auto" data-id="element-58" data-mp="1supef37qx3ts">
      <div className="bg-slate-50 p-6 border-b border-slate-200" data-id="element-59" data-mp="1r4f6txgok1i9">
        <h2 className="font-serif font-bold text-2xl text-pac-navy text-center mb-4 uppercase tracking-wide" data-id="element-60" data-mp="1m7ex9ckmggme">
          Defend Local Voices
        </h2>

        <p className="text-sm text-center text-slate-600 font-medium" data-id="element-61" data-mp="20xvzgy52zakc">
          Fundraising has begun in time for the fall elections.
        </p>
      </div>

      <div className="p-6" data-id="element-62" data-mp="1886ygksdfaiq">
        <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-63" data-mp="187e12afaxxd9">
          {presetAmounts.map(amount => <button type="button" key={amount} onClick={() => {
          setSelectedAmount(amount);
          setCustomAmount('');
        }} aria-pressed={selectedAmount === amount} className={`py-3 rounded border-2 font-bold text-lg transition-all ${selectedAmount === amount ? 'border-pac-red bg-red-50 text-pac-red' : 'border-slate-200 text-slate-700 hover:border-pac-blue hover:text-pac-blue'}`} data-id="element-64" data-mp="139vmo4iimpxv">
              {formatAmount(amount)}
            </button>)}
        </div>

        <div className="mb-6" data-id="element-65" data-mp="1q7zxc3aj0znq">
          <label htmlFor="custom-donation" className="sr-only" data-id="element-66" data-mp="1qbe2tkehloze">
            Other contribution amount
          </label>
          <div className={`relative flex items-center border-2 rounded transition-all ${selectedAmount === 'custom' ? 'border-pac-red bg-red-50' : 'border-slate-200'}`} data-id="element-67" data-mp="1z9zeqwpge5r7">
            <span className={`pl-4 font-bold ${selectedAmount === 'custom' ? 'text-pac-red' : 'text-slate-500'}`} data-id="element-68" data-mp="17itnl5rpnie2">
              $
            </span>
            <input id="custom-donation" type="number" min="1" placeholder="Other Amount" value={customAmount} onChange={event => {
            setSelectedAmount('custom');
            setCustomAmount(event.target.value);
          }} onFocus={() => setSelectedAmount('custom')} className="w-full py-3 px-2 bg-transparent outline-none font-bold text-slate-700 placeholder:text-slate-400 placeholder:font-normal" data-id="element-69" data-mp="1bikcf3xofofy" />
          </div>
        </div>

        <button type="button" onClick={handleContribute} disabled={isContributeDisabled} className="w-full bg-pac-red hover:bg-red-800 disabled:bg-slate-300 disabled:cursor-not-allowed disabled:hover:translate-y-0 text-white py-4 rounded font-bold text-xl uppercase tracking-wider transition-all shadow-[0_4px_14px_0_rgba(185,28,28,0.39)] hover:shadow-[0_6px_20px_rgba(185,28,28,0.23)] hover:-translate-y-0.5 flex items-center justify-center gap-2 group focus:outline-none focus:ring-2 focus:ring-pac-gold focus:ring-offset-2" data-id="element-70" data-mp="79bsjapgmh5o">
          Contribute Now
          <ChevronRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-71" data-mp="3aqtzlfxerk51" />
        </button>

        <div className="mt-4 flex items-center justify-center gap-2 text-xs text-slate-500" data-id="element-72" data-mp="35uloqeq8ud3o">
          <Lock className="h-3 w-3" data-id="element-73" data-mp="19q5t4y5s0n20" />
          <span data-id="element-74" data-mp="1eo7ddmexusf2">Secure, encrypted transaction via Anedot</span>
        </div>
      </div>
    </div>;
}